/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as CarouselSkeleton } from "./CarouselSkeleton";
export type { CarouselSkeletonProps } from "./CarouselSkeletonProps";
